import React from 'react';

export const ModernInvoicePageYacyretaConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth : ['master', 'rh', 'rh_not_signer', 'director', 'funcionario'],
    routes  : [
        {
            path     : '/invoice-yacyreta/:id?/:status?/:message?',
            component: React.lazy(() => import('./ModernInvoicePage'))
        }
    ]
};
